import { useEffect, useState, FC } from 'react'
import { Trade } from '@monadex/sdk'
import { Box } from '@mui/material'
import { warningSeverity, computeTradePriceBreakdown } from '@/utils/price'
const WarningSlippageComponent: FC<{ trade: Trade }> = ({ trade }) => {
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    if (!trade) return

    const { priceImpactWithoutFee } = computeTradePriceBreakdown(trade)
    const severity = warningSeverity(priceImpactWithoutFee)
   console.log('severity', severity)
    if (severity >= 3) {
      // Wait 5 seconds before showing the warning
      const timer = setTimeout(() => setShowWarning(true), 200)
      return () => clearTimeout(timer) // Cleanup the timer on component unmount or when trade changes
    } else {
      setShowWarning(false)
    }
  }, [trade])

  if (!showWarning) {
    return null
  }

  return (
    <Box className='w-[460px] mx-auto h-fit mt-2 p-2 rounded-md bg-red-400/30 mt-5 shadow-md'>
      <p className='text-red-500 text-center'>
        Price Impact too big, you may loose your money
      </p>
    </Box>
  )
}

export default WarningSlippageComponent
